import { useMemo } from 'react';
import { useOutletContext } from 'react-router-dom';
import LiveMap from '../../components/LiveMap';
import MapLegend from '../../components/MapLegend';
import AlarmModal from '../../components/AlarmModal';
import MapStatusBar from '../../components/MapStatusBar';
import OverdueBanner from '../../components/OverdueBanner';
import type { UsePortalSocketReturn } from '../../hooks/usePortalSocket';
import { useDefaultCentre } from '../../hooks/useDefaultCentre';

export default function GuardhouseDashboard() {
  const { activeGuards, alarmPins, incidentPins, historyTracks, pendingAlarm, connected, overdue, still, dismissAlarm } =
    useOutletContext<UsePortalSocketReturn>();
  const centre = useDefaultCentre();

  const guards = useMemo(() => Array.from(activeGuards.values()), [activeGuards]);

  return (
    <div className="flex flex-col h-full">
      <MapStatusBar guards={guards} connected={connected} />
      <OverdueBanner overdue={overdue} still={still} />
      {/* relative: the legend positions itself against the map, not the page */}
      <div className="flex-1 relative">
        <LiveMap guards={guards} alarmPins={alarmPins} incidentPins={incidentPins} historyTracks={historyTracks} centre={centre} zoom={16} className="h-full w-full" />
        <MapLegend />
      </div>
      {pendingAlarm && <AlarmModal alarm={pendingAlarm} onDismiss={dismissAlarm} />}
    </div>
  );
}
